import { ReactNode } from 'react';

import { AuthReadyContext } from '../contexts';

interface AuthReadyProviderProps {
  authReady: boolean;
  children: ReactNode;
}

export const AuthReadyProvider = ({
  authReady,
  children,
}: AuthReadyProviderProps): React.JSX.Element => {
  return <AuthReadyContext.Provider value={{ authReady }}>{children}</AuthReadyContext.Provider>;
};
